import { Component, DestroyRef, inject, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faArrowAltRight, faArrowAltSquareRight, faArrowSquareRight, faPlusCircle, faSortSizeDownAlt, faSortSizeUpAlt } from '@fortawesome/pro-solid-svg-icons';
import { NbToastrService } from '@nebular/theme';
import * as pdfmake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { forkJoin } from 'rxjs';
import * as _ from 'underscore';
import { US_STATES } from '../../../../@core/data/us-state-list';
import { ErrorService } from '../../../../@core/utils/error.service';
import { SessionService } from '../../../../@core/utils/session.service';
import { SelectionsContract } from '../../../../customer-integrations/hollingbery/modules/financial/contracts/models/selections-contract';
import { Items } from '../../../../customer-integrations/hollingbery/modules/financial/orders/models/items';
import { CartApiService } from '../../../../customer-integrations/hollingbery/modules/financial/orders/services/cart.service';
import { ItemsService } from '../../../../customer-integrations/hollingbery/modules/financial/orders/services/items.service';
import { OrdersService } from '../../../../customer-integrations/hollingbery/modules/financial/orders/services/orders.service';
import { PositionReportService } from '../../../../customer-integrations/hollingbery/modules/financial/position-report/services/position-report.service';
import { CropVariety } from '../../../core/models/crop-variety';
import { InventoryPackageTypeDTO } from '../../inventory/models/inventory-package-type';
import { InventoryItemDTO } from '../../inventory/models/item';
import { InventoryService } from '../../pick-plan/services/inventory.service';
import { Cart, CartItem, ContractTemplate } from '../models/cart';
import { ContractDTO } from '../models/contract';
import { currencyList } from '../models/currencyList';
import { Customer } from '../models/customer';
import { ContractService } from '../services/contract.service';
import { ContractLinesService } from '../services/contractLines.service';
import { CustomerService } from '../services/customer.service';
import { PDFService } from '../services/pdf.service';
import { SupportService } from '../services/support.service';




@Component({
  selector: 'contract-ammend',
  templateUrl: './contract-ammend.component.html',
  styleUrls: ['./contract-ammend.component.scss']
})

export class ContractAmmendComponent implements OnInit, OnChanges {

  private destroyRef = inject(DestroyRef);

  public faEdit = faEdit;
  public faTrash = faTrash;
  public faPlus = faPlusCircle;
  public faSortSizeUpAlt = faSortSizeUpAlt;
  public faSortSizeDownAlt = faSortSizeDownAlt;
  faArrowAltSquareRight = faArrowAltSquareRight;
  faArrowAltRight = faArrowAltRight;
  faArrowSquareRight = faArrowSquareRight;
  public ExpirationDate: Date = new Date();
  public EffectiveDate: Date = new Date();

  public cart: Cart = {
    items: [],
    shippingAddress: {},
    
  };


  public listOfItems: Items[] = [];
  public selectedLineIndex: number = -1;
  allContracts: SelectionsContract[] = [];
  contractList: SelectionsContract[] = [];
  public customerList: Customer[] = [];
  public allCustomers: Customer[] = [];
  public searchCustomer: string = '';
  public searchItemNumber: string = '';
  public searchItemDesc: string = '';

  public isItemAsc: boolean = false;
  public isContractYearAsc: boolean = false;
  public isVarietyAsc: boolean = false;
  public isCropYearAsc: boolean = false;
  public isPkgTypeAsc: boolean = false;
  public isPkgSizeAsc: boolean = false;
  public isContractAmountAsc: boolean = false;
  public isContractTypeAsc: boolean = false;

  public varieties: CropVariety[] = [];
  public contractTemplates: ContractTemplate[] = [];
  public inventoryItems: InventoryItemDTO[] = [];
  public itemList: InventoryItemDTO[] = [];
  public currencyList = [];

  public packages: InventoryPackageTypeDTO[];
  public isLoading: boolean = true;

  public states = US_STATES;
  public isSubmitted: boolean = false;
  public setItemFocus: boolean = true;

  // public order: Order = {};
  public allItems: Items[] = [];

  public paramId: string;
  public isEdit: boolean = false;
  // saved lines removed from an existing amendment; marked inactive on save
  inActiveItems: any[] = [];
  private logoBase64: string = null;

  // @ViewChild('orderForm') public form: NgForm;

  constructor(
    private customerService: CustomerService,
    private errorService: ErrorService,
    private orderService: OrdersService,
    private supportServices: SupportService,
    private pdfService: PDFService,
    private contractLineService: ContractLinesService,
    private cartService: CartApiService,
    private router: Router,
    private session: SessionService,
    private positionReportService: PositionReportService,
    private itemsService: ItemsService,
    private contractService: ContractService,
    private inventoryService: InventoryService,
    private tostrService: NbToastrService,
    private route: ActivatedRoute,
  ) {
    this.ExpirationDate.setDate(this.ExpirationDate.getDate() + 14);
   }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.setItemFocus) {
      document.getElementById('itemInput').focus();
      this.setItemFocus = false;
    }
  }

  ngOnInit() {
    
    this.loadAll();
    this.getPdfLogo();
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.paramId = params.get('contractId');
      this.isEdit = params.get('edit') == 'true';
    });
    pdfmake.vfs = pdfFonts.pdfMake.vfs;

   const keys = Object.keys(currencyList)
   this.currencyList = keys

  }
  getPdfLogo() {
    this.pdfService.getBase64ImageFromURL(window.location.origin + '/assets/images/HB_Logo_black.png')
      .then(base64 => { this.logoBase64 = base64 as string; })
      .catch(() => {});
  }

  preLoadfields(){
    let contract = this.session.contract
    contract.contractLine.sort((a, b) => {
      return a.timeCreated > b.timeCreated ? 1 : -1
    })

    if(Object.keys(contract.contractLine).length > 0){
      contract.contractLine.forEach((item) => {
        // let varietyObj = this.varieties.find(v => v.id == item.varietyId)
        let inventoryObj = this.inventoryItems.find(i => i.id == item.inventoryItemId)
        // let packageObj = this.packages.find(p => p.id == item.packageId)

        // Only add line item if inventory item is found (and the line wasn't removed from the amendment)
        if (inventoryObj && item.isActive !== false) {
          this.cart.items.push({
            id: item.id,
            // varietyObj: varietyObj,
            // packageObj: packageObj,
            inventoryItem: inventoryObj,
            cropYear: item.cropYear,
            quantity: this.isEdit ? item.quantityPrevious : item.quantity,
            quantityAmend: item.quantity,
            unitOfMeasure: item.unitOfMeasure,
            price: this.isEdit ? item.pricePrevious : item.price,
            priceAmend: item.price,
            currency: item.currency,
          })
        }

    })
  }

  // if(contract.parentId && this.isEdit){
  //     this.contractLineService.getContractLinesByContractId(contract.parentId).subscribe(y => {
  //     //   this.cart.items.forEach((item, idx) => {
  //     //     item.price = y.

  //     // })
  //   })
  // }

    this.cart.customerId = contract.customerId
    this.cart.contractYear = contract.contractYear
    this.cart.contractTemplate = this.contractTemplates.find(c => c.name == 'Amendment')
    this.cart.contractTemplate.otherRemarks = contract.otherRemarks
    this.EffectiveDate = contract.effectiveDate
    this.ExpirationDate = contract.expirationDate
    
    this.filterProducts();
    this.filterCustomers();
    this.onCustomerSelect();
    this.isLoading = false;
  }
  loadAll() {
    forkJoin([
      this.customerService.getCustomerList(),
      this.contractService.getContractTemplates(),
      this.inventoryService.getInventoryItems()
    ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:values => {
      this.allCustomers = values[0];
      this.contractTemplates = values[1].filter(x=>x.templateType == 'contract');
      this.inventoryItems = values[2];
      
      if(this.session.contract){
        this.preLoadfields()
      } else if (this.paramId) {
        forkJoin([
          this.contractService.getContractById(+this.paramId),
          this.contractLineService.getContractLinesByContractId(+this.paramId)
        ]).subscribe(([contract, lines]: [ContractDTO, any]) => {
          contract.contractLine = lines || [];
          this.session.contract = contract;
          this.preLoadfields();
        }, err => this.errorService.handleError(err));
      } else {
        this.filterCustomers();
        this.filterProducts();
        this.onCustomerSelect()
        this.addLine();
        this.isLoading = false;
      }
    }, error:err => this.errorService.handleError(err)});
  }

  validateContract() {
    if(this.cart.contractTemplate && this.cart.contractTemplate.name == 'MSA'){
      if(this.cart.contractYear &&
        this.cart.shippingAddress &&
        this.cart.shippingAddress.company &&
        this.cart.customer &&
        this.cart.customer.id){
          this.saveContract()
      } else {
        alert('Please fill out all required fields')
      }
    } else {
      if (!this.cart.items || this.cart.items.length == 0) {
        alert('Please add at least one line item')
        return;
      }
      let valid = false;
      for(let i = 0; i < this.cart.items.length; i ++) {
        if(this.cart.items[i].inventoryItem &&
          this.cart.items[i].inventoryItem.id &&
          (this.cart.items[i].quantity || this.cart.items[i].quantity == 0) &&
          (this.cart.items[i].quantityAmend || this.cart.items[i].quantityAmend == 0) &&
          (this.cart.items[i].priceAmend || this.cart.items[i].priceAmend == 0) &&
          (this.cart.items[i].price || this.cart.items[i].price == 0) &&
          this.cart.items[i].currency) {
          valid = true;
        } else {
          valid = false;
          alert('Please fill out all required fields')
          break;
        }
      }
      if(valid) {
        this.saveContract()
      }
    }
  }

  saveContract() {

    // let cartItems = this.cart.items;
    // cartItems.map((item, idx) => {
    //   item.quantity = this.cart.items[idx].quantityAmend  
    //   item.price = this.cart.items[idx].priceAmend
    //   item.currency = this.cart.items[0].currency
    //   item.unitOfMeasure = this.cart.items[0].unitOfMeasure
    //   item.packageObj = this.cart.items[0].packageObj
    // })

    let body: ContractDTO = {
      // id: +this.paramId,
      contractYear: this.cart.contractYear, 
      contractStatus: 'Created',
      expirationDate: this.ExpirationDate,
      effectiveDate: this.EffectiveDate,
      customerId: this.cart.customerId, 
      customerName: this.cart.shippingAddress.company, 
      contractTemplateId: this.cart.contractTemplate.id, 
      contractTemplateName: this.cart.contractTemplate.name, 
      // comments: this.cart.userMessage,
      otherRemarks: this.cart.contractTemplate.otherRemarks,
      isActive: true,
      parentId: this.session.contract.parentId || +this.paramId,
    }
    let pdfPayload = {
      ContractYear: this.cart.contractYear,
      CurrentDate: new Date().toLocaleDateString('default', {month: '2-digit', day: '2-digit', year: '2-digit'}),
      ExpirationDate: new Date(this.ExpirationDate).toLocaleDateString('default', {month: '2-digit', day: '2-digit', year: '2-digit'}),
      EffectiveDate: new Date(this.EffectiveDate).toLocaleDateString('default', {month: '2-digit', day: '2-digit', year: '2-digit'}),
      Address: this.cart.shippingAddress,
      LineItems: this.cart.items,
      // LineItemsAmended: this.cart.itemsAmend,
      LineItemsAmended: this.cart.items,

      Verbiage: this.cart.contractTemplate.verbiage,
      LastId: this.paramId || 0,
      OtherRemarks: this.cart.contractTemplate.otherRemarks
    }

    if(this.paramId && this.session.contract && this.isEdit == true){
      this.contractService.getContractById(+this.session.contract.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
        body = x;
        body.contractYear = this.cart.contractYear
        // body.contractStatus = 'Created'
        body.expirationDate = this.ExpirationDate
        body.effectiveDate = this.EffectiveDate
        body.customerId = this.cart.customerId
        body.customerName = this.cart.shippingAddress.company
        body.contractTemplateId = this.cart.contractTemplate.id
        body.contractTemplateName = this.cart.contractTemplate.name,
        body.comments = this.cart.userMessage
        body.otherRemarks = this.cart.contractTemplate.otherRemarks

      const contractPdf = this.pdfService.generateVerbiage(pdfPayload, null, this.logoBase64);
      body.contractVerbiage = JSON.stringify(contractPdf);
      this.contractService.putContract(body, +this.paramId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
        if(this.cart.items && this.cart.items.length > 0 && Object.keys(this.cart.items[0]).length > 1){
          this.cart.items.concat(this.inActiveItems).map(async item => {
            if(item.id){
              this.contractLineService.getContractLinesById(item.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async y => {
                let lineItem = y;
                lineItem.varietyId = item.inventoryItem.varietyId
                // lineItem.varietyName = item.varietyObj.name
                lineItem.packageId = item.inventoryItem.packageTypeId
                // lineItem.packageName = item.packageObj.name
                lineItem.cropYear = item.cropYear
                lineItem.quantity = item.quantityAmend
                lineItem.quantityPrevious = item.quantity
                lineItem.price = item.priceAmend
                lineItem.pricePrevious = item.price
                lineItem.contractId = this.paramId
                lineItem.currency = item.currency
                lineItem.unitOfMeasure = item.unitOfMeasure
                lineItem.inventoryItemId = item.inventoryItem.id
                if (item.isActive === false) lineItem.isActive = false;
                const result = await this.contractLineService.putContractLines(lineItem).toPromise();
              })
            } else {
              let postItem: any = {
                varietyId: item.inventoryItem.varietyId == 0 ? null : item.inventoryItem.varietyId,
                packageId: item.inventoryItem.packageTypeId == 0 ? null : item.inventoryItem.packageTypeId,
                cropYear: item.cropYear,
                quantity: item.quantityAmend,
                quantityPrevious: item.quantity,
                price: item.priceAmend,
                pricePrevious: item.price,
                contractId: +this.paramId,
                currency: item.currency,
                unitOfMeasure: item.unitOfMeasure,
                inventoryItemId: item.inventoryItem.id,
              };
              const result = await this.contractLineService.postContractLines(postItem).toPromise();
            }
          })
        }
        this.pdfService.downloadPDF(contractPdf)
        this.session.contract = null;
      })
    })
    } else {
      this.contractService.postContract(body).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        pdfPayload.LastId = x.id
        const contractPdf = this.pdfService.generateVerbiage(pdfPayload, this.session.contract.offerNumber, this.logoBase64);

        body = x
        body.contractVerbiage = JSON.stringify(contractPdf)
        body.offerNumber = this.session.contract.offerNumber
        this.contractService.putContract(body, x.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
          // console.log(x)
        })

        this.saveContractLinesSequentially(x);
        
        this.pdfService.downloadPDF(contractPdf)
        this.session.contract = null;
      }, error:err => { this.errorService.handleError(err); console.error(err)}});
    }
    setTimeout(() => {
      this.router.navigateByUrl(`/harvest-engine/contracts/contract-list`)
    },2000)
  }

 saveContractLinesSequentially = async(x) => {
    for (const item of this.cart.items) {
      let lineItem = {
        // id: null,
        varietyId: item.inventoryItem.varietyId == 0 ? null : item.inventoryItem.varietyId,
        // varietyName: item.varietyObj.name,
        packageId: item.inventoryItem.packageTypeId == 0 ? null : item.inventoryItem.packageTypeId,
        // packageName: item.packageObj.name,
        cropYear: item.cropYear,
        quantity: item.quantityAmend,
        quantityPrevious: item.quantity,
        price: item.priceAmend,
        pricePrevious: item.price,
        contractId: x.id,
        currency: item.currency,
        unitOfMeasure: item.unitOfMeasure,
        inventoryItemId: item.inventoryItem.id,

      }
      const result = await this.contractLineService.postContractLines(lineItem).toPromise();
    }
  }


  onExpirationChange(event) {
    this.ExpirationDate = event.value
  }
  onEffectiveChange(event){
    this.EffectiveDate = event.value
  }

  // Only lines added in this amendment (nothing on the original contract) can be removed. Removing an original line
  // would read as a cancellation on the position report; to cancel one, set its Amended quantity to 0 instead.
  canDeleteLine(line) {
    return !line.quantity;
  }

  deleteLine(index) {
    const line = this.cart.items[index];
    this.cart.items.splice(index, 1);
    if (line && line.id > 0) {
      line.isActive = false;
      this.inActiveItems.push(line);
    }
    this.selectedLineIndex = this.cart.items.length - 1;
    this.addExistingItemToItemList();
  }

  editLine(index) {
    this.selectedLineIndex = index;
    // this.searchItemNumber = this.cart.items[this.selectedLineIndex].itemNumber;
    this.addExistingItemToItemList();
  }

  addLine() {
    let lineItem = this.cart.items[this.selectedLineIndex];

    let amendedLineItem = this.cart.items[this.selectedLineIndex];

      if (
            (
              lineItem
              && lineItem.inventoryItem 
              && (amendedLineItem.priceAmend || amendedLineItem.priceAmend == 0)
              && (amendedLineItem.quantityAmend || amendedLineItem.quantityAmend == 0)
            )
            || this.selectedLineIndex == -1
          ){
        this.cart.items.push({
          currency: 'USD',
          price: 0,
          quantity: 0,
          priceAmend: 0,
          quantityAmend: 0,
          inventoryItem: {name: '', description:''}
          
        });
        this.selectedLineIndex = this.cart.items.length - 1;
        this.setItemFocus = true;
      } else {
        alert('Missing fields')
      }
      

  }
  addLineItem(){
    
  }


  filterCustomers() {
    let filterCustomers = this.allCustomers.filter(x => x.id == this.cart.customerId || this.searchCustomer === '' || x.name.toLowerCase().includes(this.searchCustomer.toLowerCase()));

    if (filterCustomers.length > 20)
      this.customerList = [];
    else
      this.customerList = _.sortBy(filterCustomers, 'Name');

    // add selected brewery so it shows in the list
    if (this.cart && this.cart.customerId !== 0) {
      if (this.customerList.filter(x => x.id == this.cart.customerId).length === 0) {
        let selectedBrewery = this.allCustomers.filter(x => x.id == this.cart.customerId)[0];
        if (selectedBrewery) {
          this.customerList.push(selectedBrewery);
        }
      }
    }
  }

  onCustomerSelect() {
    let selectedCustomer = this.allCustomers.filter(x => x.id == this.cart.customerId)[0];

    if (selectedCustomer) {
      this.cart.customerId = selectedCustomer.id;
      this.cart.shippingAddress = {
        address: selectedCustomer.shipAddress,
        city: selectedCustomer.shipAddressCity,
        company: selectedCustomer.name,
        state: selectedCustomer.shipAddressState,
        zip: selectedCustomer.shipAddressPostalCode,
        phoneNumber: selectedCustomer.phone,
        email: selectedCustomer.email,
        faxNumber: selectedCustomer.faxNumber
      }

    }
  }

  comparePackages(o1: number, o2: number) {
    return o1 == o2;
  }

  onItemSelect(itemNumber: string) {
    let selectedItem = this.allItems.filter(x => x.parentRefFullName == itemNumber)[0];
    
    this.cart.items[this.selectedLineIndex].variety = selectedItem.customFieldVariety;
    this.cart.items[this.selectedLineIndex].cropYear = +selectedItem.customFieldCropYear;
  }


  addExistingItemToItemList() {
    if (this.cart && this.allItems && this.cart.items[this.selectedLineIndex]) {
      let selectedItem = this.allItems.filter(x => x.parentRefFullName == this.cart.items[this.selectedLineIndex].itemNumber)[0];


      if (selectedItem) {
        // if the selected item doesn't already exist
        if (!this.listOfItems.filter(x => x.parentRefFullName == selectedItem.parentRefFullName)[0]) {
          this.listOfItems.push(selectedItem);
        }
      }
    }
    this.filterProducts();
  }




  setPackage(event: InventoryPackageTypeDTO, lineItem: CartItem) {

    let selectedPackingOption = this.packages.find(x => x.id == event.id);
    
    if(selectedPackingOption){
      lineItem.packageObj = selectedPackingOption;
      // lineItem.packageTypeName = selectedPackingOption.name;
      // lineItem.packageType = +selectedPackingOption.bagSize;
      // lineItem.packageName = selectedPackingOption.boxType;
    }
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getTotalPrice() {
    let totalPrice: number = 0;
    
    if (this.cart.items) {
      for (let x of this.cart.items) {
        if (x.price != undefined || x.price != null) {
          totalPrice = totalPrice + (x.price * x.quantity);
        }
      }
      return totalPrice;
    }
  }

  getTotalAmendedPrice() {
    let totalPrice: number = 0;
    if (this.cart.items) {
      for (let x of this.cart.items) {
        if (x.priceAmend != undefined || x.priceAmend != null) {
          totalPrice = totalPrice + (x.priceAmend * x.quantityAmend);
        }
        // if (x.packageType === 0 && x.itemNumber === 'CC Fee' || x.packageType === 0 && x.itemNumber === 'Bag Fee') {
        //   totalPrice = totalPrice + x.price;
        // }
      }
      return totalPrice;
    }
  }
  filterProducts() {

    this.itemList = this.inventoryItems.filter(x => this.searchItemNumber === '' || (x.name != null && x.name.toLowerCase().includes(this.searchItemNumber.toLowerCase())));

    // if (this.itemList.length > 1000)
    if(this.searchItemNumber.length < 2){
      this.itemList = [];
    } else {
      this.itemList = _.sortBy(this.itemList, 'Name');
      // this.itemList.push(filterProducts)
    }
    // add selected brewery so it shows in the list
    if (this.cart && this.cart.items.length > 0 && this.selectedLineIndex != -1 && this.cart.items[this.selectedLineIndex].inventoryItem) {
      if (this.itemList.filter(x => x.id == this.cart.items[this.selectedLineIndex].inventoryItem.id).length === 0) {
        let selectedItem = this.inventoryItems.filter(x => x.id == this.cart.items[this.selectedLineIndex].inventoryItem.id)[0];
        if (selectedItem) {
          this.itemList.push(selectedItem);
        }
      }
    }
  }

  filterProductDesc() {
    this.itemList = this.inventoryItems.filter(x => this.searchItemDesc === '' || (x.description != null && x.description.toLowerCase().includes(this.searchItemDesc.toLowerCase())));

    // if (this.itemList.length > 1000)
    if(this.searchItemDesc.length < 2){
      this.itemList = [];
    } else {
      this.itemList = _.sortBy(this.itemList, 'Description');
      // this.itemList.push(filterProducts)
    }
    // add selected brewery so it shows in the list
    if (this.cart && this.cart.items.length > 0 && this.cart.items[this.selectedLineIndex].inventoryItem) {
      if (this.itemList.filter(x => x.id == this.cart.items[this.selectedLineIndex].inventoryItem.id).length === 0) {
        let selectedItem = this.inventoryItems.filter(x => x.id == this.cart.items[this.selectedLineIndex].inventoryItem.id)[0];
        if (selectedItem) {
          this.itemList.push(selectedItem);
        }
      }
    }
  }


}
